import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
    plugins: [
        createPersistedState()
    ],
    state: {
        ticket: '',
        sign: '',
        loginCheck: false,
        adult: false,
        alarm: false,
        attBounsPoint: 0,
        attPoint: 0,
        createDate: '',
        email: '',
        leaveDate: '',
        nationality: '',
        nickName: '',
        pgBounsPoint: 0,
        pgPoint: 0,
        photo: '',
        rank: 0,
        social: '',
        state: false,
        writerIdx: 0,
        chargeCount: 0,
        erc20Address: '',

        isCheckedAdult: false,
        
        metamask: '',
        kaikas: '',

        account: '',
        attTokenBalance: 0,

        isEnableMetamask: false,
        isEnableKaikas: false,

        tokenInfo: null,
        tokenInfoTimerCount: 0,
    },
    mutations: {
        setEmail: function (state, email) {
            state.email = email;
        },
        loginTicket: function (state, ticket) {
            state.ticket = ticket;
            state.loginCheck = true;
        },
        loginSign: function (state, sign) {
            state.sign = sign;
        },
        logout: function (state) {
            state.ticket = '',
            state.sign = '',
            state.loginCheck = false,
            state.adult = false,
            state.alarm = false,
            state.attBounsPoint = 0,
            state.attPoint = 0,
            state.createDate = '',
            state.email = '',
            state.leaveDate = '',
            state.nationality = '',
            state.nickName = '',
            state.pgBounsPoint = 0,
            state.pgPoint = 0,
            state.photo = '',
            state.rank = 0,
            state.social = '',
            state.state = false,
            state.writerIdx = 0,
            state.chargeCount = 0,
            state.erc20Address = '',

            state.isCheckedAdult = false,
            state.metamask = '',
            state.kaikas = '',

            state.account = '',
            state.attTokenBalance = 0,

            state.isEnableMetamask = false,
            state.isEnableKaikas = false,

            state.tokenInfo = null,
            state.tokenInfoTimerCount = 0
        },
        setProfile: async function (state, host) {
            
            var param = 
            {
                // k: '9999000',
                // t: new Date().getTime(),
                sign: state.sign,
                ticket: state.ticket,
                viewAdult: state.isCheckedAdult ? 1 : 0
            }

            await axios.post(`${host}/member/info`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Contcurrent-type': 'application/json', }}).then(async(res)=> {
                // console.log(res.data);
                if (res.data.returnCode === 0) {
                    state.adult         = res.data.data.adult        ;
                    state.alarm         = res.data.data.alarm        ;
                    state.attBounsPoint = res.data.data.attBounsPoint;
                    state.attPoint      = res.data.data.attPoint     ;
                    state.createDate    = res.data.data.createDate   ;
                    state.email         = res.data.data.email        ;
                    state.leaveDate     = res.data.data.leaveDate    ;
                    state.nationality   = res.data.data.nationality  ;
                    state.nickName      = res.data.data.nickName     ;
                    state.pgBounsPoint  = res.data.data.pgBounsPoint ;
                    state.pgPoint       = res.data.data.pgPoint      ;
                    state.photo         = res.data.data.photo        ;
                    state.rank          = res.data.data.rank         ;
                    state.social        = res.data.data.social       ;
                    state.state         = res.data.data.state        ;
                    state.writerIdx     = res.data.data.writerIdx    ;
                    state.chargeCount   = res.data.data.chargeCount  ;
                    state.erc20Address  = res.data.data.erc20Address ;

                    // console.log(state.ticket        );
                    // console.log(state.sign          );
                    // console.log(state.loginCheck    );
                    // console.log(state.adult         );
                    // console.log(state.alarm         );
                    // console.log(state.attBounsPoint );
                    // console.log(state.attPoint      );
                    // console.log(state.createDate    );
                    // console.log(state.email         );
                    // console.log(state.leaveDate     );
                    // console.log(state.nationality   );
                    // console.log(state.nickName      );
                    // console.log(state.pgBounsPoint  );
                    // console.log(state.pgPoint       );
                    // console.log(state.photo         );
                    // console.log(state.rank          );
                    // console.log(state.social        );
                    // console.log(state.state         );
                    // console.log(state.writerIdx     );
                }
            })
        },
        checkAdult: function (state, flag){
            state.isCheckedAdult = flag;
        },
        disconnectMetamask: function (state){
            state.metamask = '',
            state.account = '',
            state.attTokenBalance = 0,
            state.isEnableMetamask = false
        },
        disconnectKaikas: function(state){
            state.kaikas = '',
            state.account = '',
            state.attTokenBalance = 0,
            state.isEnableKaikas = false
        }

    },
    actions: {

    },
    modules: {

    }
})
